import React from 'react';
import I18n from '@/modules/i18n';
import Icon from '@/components/ui/Icon';

export function ReadingAssignmentTableLegend() {
  return (
    <div className="tw-flex tw-gap-6 tw-mt-6 tw-mr-4 tw-justify-end">
      <span className="tw-inline-flex tw-items-center tw-gap-2">
        <Icon
          fill="#78962d"
          icon="Circle"
          size={12}
        />
        {I18n.t('turned_in')}
      </span>
      <span className="tw-inline-flex tw-items-center tw-gap-2">
        <Icon
          fill="#ffca17"
          icon="Circle"
          size={12}
        />
        {I18n.t('in_progress')}
      </span>
    </div>
  );
}
